module.exports = __webpack_public_path__ + "static/media/20170830_105950 (1).453a2114.jpg";